import {ES_TIP_TYPES} from '@/consts/experienceScore/esTipTypes';
import insightsAndTipsCodes from '@/consts/experienceScore/insightsAndTipsCodes';
import rangeModeRecommendations from '@/consts/experienceScore/rangeModeRecommendations';
import type {TipData} from '@/types/experienceScore';
import type {BackToBackBreakdown, InsightsAndTipsEntry} from '@/types/inference';

import metricMapping from './metricMapping';

interface RangeModeTipContext {
    insightsAndTips?: Record<string, InsightsAndTipsEntry> | null;
    isRangeModeEnabled: boolean;
}

const getRecommendationTip = ({insightsAndTips, isRangeModeEnabled}: RangeModeTipContext): TipData | null => {
    const entry = insightsAndTips?.[insightsAndTipsCodes.RANGE_PROFILE] as BackToBackBreakdown | undefined;
    const recommendation = entry?.recommendation ?? null;

    if (!recommendation) return null;
    if (recommendation === rangeModeRecommendations.ENABLE && isRangeModeEnabled) return null;
    if (recommendation === rangeModeRecommendations.DISABLE && !isRangeModeEnabled) return null;

    const rec = metricMapping
        .getMetric(insightsAndTipsCodes.RANGE_PROFILE)
        ?.recommendations?.find((r) => r.key === recommendation);

    if (!rec?.description) return null;

    const {icon, title, description, button} = rec;
    const tipData: TipData = {
        icon,
        title,
        description,
        code: insightsAndTipsCodes.RANGE_PROFILE,
        action: button?.action,
        tipsGroupType: button?.tipsGroupType,
        trackingValue: button?.trackingValue,
        deviceSettingType: button?.deviceSettingType,
        type: ES_TIP_TYPES.SUGGEST,
    };

    return button?.text ? {...tipData, isButtonActive: true, btnText: button.text} : tipData;
};

export default {
    getRecommendationTip,
};
